<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-09 12:59:49
 * @LastEditors: xulongyong
 * @LastEditTime: 2024-09-06 17:24:43
 * @FilePath: \vue-privilege-routing\src\pages\website\website.vue
-->

<template>
  <div id="login_wrap">
    <div class="website-tabs">
      <div class="box">
        <h1>
          <!-- <img src="../assets/logo.png"> -->
          <span>Aubuary</span>
        </h1>
        <nav>
          <router-link active-class="active" class="active_first" to="/website"
            >首页</router-link
          >
          <router-link active-class="active" to="/websiteAdvice"
            >方案咨询</router-link
          >
          <!-- 免费咨询      付费资询     战略规划 -->
          <router-link active-class="active" to="/websiteCustomize"
            >企业定制</router-link
          >
          <!-- 小程序开发    网站开发     APP开发    -->
          <router-link active-class="active" to="/websiteTechnology"
            >技术服务</router-link
          >
          <!--  SaaS服务    开放接口     技术购买   技术支持   技术外包-->
          <router-link active-class="active" to="/websiteCompany"
            >关于我们</router-link
          >
          <!--  活在当下    寻求突破     畅想未来    诗和远方 -->
          <router-link active-class="active" to="/websiteInvest"
            >投资加盟</router-link
          >
          <!-- 深蓝(发动机简笔当图标)学院    定制服务    技术服务 -->
        </nav>
      </div>
    </div>
    <div class="website-content">
      <div class="website-mission">
        <div class="mission mission-logo">星火城</div>
        <div class="mission mission-describe">
          打造企业全周期数字技术服务品牌
        </div>
        <div>
          <span>第一个有点你懂</span>
          <span>第二个有点你懂</span>
          <span>第三个有点你懂</span>
        </div>
        <div>
          <span>第四个有点你懂</span>
          <span>第五个有点你懂</span>
          <span>第六个有点你懂</span>
        </div>
      </div>
      <div class="website-right">
        <div class="login_form">
          <el-tabs type="border-card" :stretch="true">
            <el-tab-pane label="账户登录"
              ><div id="login">
                <div class="login--account">
                  <span>账号：</span>
                  <input
                    type="text"
                    placeholder="随便输"
                    name="account"
                    @change="checkLogin($event)"
                    v-model.trim="account"
                  />
                </div>
                <div class="login--account">
                  <span>机构：</span>
                  <el-select v-model="rolesLists" placeholder="请选择">
                    <el-option
                      v-for="item in units"
                      :key="item.organizeId"
                      :label="item.organizeShorthand"
                      :value="item.rolesLists"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="login--password">
                  <span>密码：</span>
                  <input
                    type="password"
                    placeholder="随便输"
                    name="password"
                    v-model.trim="password"
                    @keyup.enter="login"
                  />
                  <div class="forget-pw-safe">
                    <a
                      href="//passport.jd.com/uc/links?tag=safe"
                      target="_blank"
                      clstag="pageclick|keycount|passport_main|click_forget_pwd"
                      >忘记密码</a
                    >
                  </div>
                </div>

                <div
                  style="width: 100%; display: flex; justify-content: center;"
                >
                  <button class="button-login" @click="doLogin">登录</button>
                </div>
              </div>
              <div class="register-safe">
                <a
                  href="http://localhost:8080/register"
                  target="_blank"
                  clstag="pageclick|keycount|passport_main|click_forget_pwd"
                  >没有账号,请点击注册</a
                >
              </div>
            </el-tab-pane>
            <el-tab-pane label="扫码登录">扫码登录</el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { doLogin, checkLogin, registerSubmit } from '../../api'

export default {
  data() {
    return {
      loading: false,
      units: [],
      rolesLists: [],
      account: '',
      password: '',
      roleId: ''
    }
  },
  methods: {
    async doLogin() {
      const data = {
        account: this.account,
        organizeId: this.rolesLists[0].organizeId,
        roleId: this.rolesLists[0].roleId
      }
      // 网络请求
      let result = await doLogin(data)
      let token = result.token
      let account_token = result.account_token

      // 本地  vuex
      this.$store.commit('LOGIN_IN', token)
      this.$store.commit('ACCOUNT_TOKEN', result.account_token)
      this.$router.replace('/')
    },

    async checkLogin(e) {
      const data = {
        account: e.srcElement._value
      }
      // 网络请求
      let result = await checkLogin(data)
      this.units = result

      console.log('result.data', result)
    },

    doRegister() {
      console.log('点击这里,需要跳转到注册页面!')
    }
  },
  mounted() {}
}
</script>
<style scoped lang="scss">
#login_wrap {
  position: relative;
  background-image: url('../../assets/website_back.png');
  background-size: cover;
  display: flex;
  flex-wrap: wrap;
  h1 {
    color: white;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
  }
}
.website-tabs {
  // background-color: red;
  height: 12%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}
.website-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  .website-mission {
    // background-color: aqua;
    height: 100%;
    width: 60%;
    display: flex;
    padding: 280px 10px 10px 160px;
    flex-direction: column;
    .mission {
      font-weight: bold;
      color: white;
    }
    .mission-logo {
      font-size: 68px;
    }
    .mission-describe {
      font-size: 56px;
      margin-bottom: 26px;
    }
    span {
      margin-right: 120px;
      color: white;
    }
  }
  .website-right {
    width: 40%;
    
    .login_form {
    width: 48%;
    line-height: 68px;
    margin: 200px 0px 0px 128px;

    #login {
      margin-top: 36px;
    }

    span {
      color: #666;
      // display: inline-block;
      width: 24%;
      font-size: 20px;
      margin-left: 27px;
    }
    input {
      background: none;
      font-size: 16px;
      border: 1px solid rgb(223, 222, 222);
      border-radius: 4px;
      height: 20%;
      width: 234px;
      padding: 10px;
      box-sizing: border-box;
      color: #666;
      &.error {
        border: 1px solid #f00;
      }
      &::-webkit-input-placeholder {
        color: #aaa;
      }
    }
    .el-select {
      width: 234px;
    }

    .button-login {
      display: block;
      width: 90%;
      height: 42px;
      font-size: 18px;
      background: #0f6171;
      border: none;
      color: #fff;
      border-radius: 6px;
      cursor: pointer;
    }
    .forget-pw-safe {
      line-height: 36px;
      margin-left: 80%;
      font-size: 12px;
      padding-bottom: 6px;
      a:hover {
        border-bottom: 1px solid #f00;
        color: #f00;
      }
    }
    .register-safe {
      line-height: 32px;
      padding-left: 51%;
      font-size: 16px;
      padding-top: 16px;
      a:hover {
        border-bottom: 1px solid #f00;
        color: #f00;
      }
    }
  }
  }
}

/* ---  banner样式开始  --- */
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  color: #ffffff;
}
.box {
  display: flex;
  align-items: center;
}
h1 {
  display: flex;
  align-items: center;
  font: normal 28px Cookie, Arial, Helvetica, sans-serif;
  padding: 0px 20px;
}
img {
  width: 40px;
  height: 40px;
}

nav {
  display: flex;
  align-items: center;
  margin: 0px 40px;
  font: 16px Arial, Helvetica, sans-serif;
}
nav a {
  padding: 0 15px;
  width: 150px;
  text-decoration: none;
  color: #ffffff;
  font-size: 24px;
  font-weight: normal;
  opacity: 0.9;
}

nav a:hover {
  opacity: 1;
}

.active {
  color: #608bd2;
  pointer-events: none;
  opacity: 1;
}
.active-first {
  text-align: center;
}
/* ---  banner样式结束  --- */
</style>
